/**
 * @generated SignedSource<<a6253d4fc79b5abbecf6f14b10a64538>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserBalanceQuery$variables = {};
export type UserBalanceQuery$data = {
  readonly targetRedemptionValue: {
    readonly " $fragmentSpreads": FragmentRefs<"UserBalance_target">;
  } | null;
  readonly walletBalance: {
    readonly amount: {
      readonly currency: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"UserBalance_balance">;
  } | null;
};
export type UserBalanceQuery = {
  response: UserBalanceQuery$data;
  variables: UserBalanceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formatted",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subUnitAmount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserBalanceQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserBalance_balance"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "amount",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AmountDenomination",
        "kind": "LinkedField",
        "name": "targetRedemptionValue",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserBalance_target"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserBalanceQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "amount",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AmountDenomination",
        "kind": "LinkedField",
        "name": "targetRedemptionValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "panelistCost",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "redemptionAmount",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "10c53da3cda01b200c77107ee19f6ced",
    "id": null,
    "metadata": {},
    "name": "UserBalanceQuery",
    "operationKind": "query",
    "text": "query UserBalanceQuery {\n  walletBalance {\n    ...UserBalance_balance\n    amount {\n      currency\n    }\n    id\n  }\n  targetRedemptionValue {\n    ...UserBalance_target\n  }\n}\n\nfragment UserBalance_balance on WalletBalance {\n  amount {\n    currency\n    formatted\n    subUnitAmount\n  }\n  id\n}\n\nfragment UserBalance_target on AmountDenomination {\n  panelistCost {\n    subUnitAmount\n  }\n  redemptionAmount {\n    formatted\n  }\n}\n"
  }
};
})();

(node as any).hash = "c6ff9bcb90885e6f6e4c8dc1b61cf13a";

export default node;
